import React from 'react';
import { useInView } from 'react-intersection-observer';
import './Home.scss';
import './About.scss';
import highlightExpert from '../assets/images/content/highlight-expert.svg';
import logoSvg from "../assets/images/logos/logo_only_gray.svg";
import Footer from "../components/Footer";

const styles = {
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '2rem',
        padding: '2rem',
        maxWidth: '1200px',
        margin: '0 auto',
        flexWrap: 'wrap',
    },
    imageContainer: {
        flex: '1 1 300px',
        maxWidth: '300px',
        zIndex: '2'
    },
    image: {
        width: '100%',
        height: 'auto',
        borderRadius: '10px',
    },
    profileCard: {
        marginTop: '1rem',
        padding: '1rem',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        textAlign: 'center',
    },
    profileName: {
        margin: 0,
        fontWeight: '600',
        fontSize: '1.2rem',
    },
    profileTitle: {
        margin: 0,
        fontSize: '1rem',
        color: '#555',
    },
    profileDetails: {
        marginTop: '1rem',
        fontSize: '0.95rem',
        color: '#444',
        lineHeight: '1.6',
    },
    textContainer: {
        flex: '2 1 600px',
        lineHeight: '1.7',
        fontSize: '1rem',
        color: '#333',
        textAlign: 'left',
        zIndex:2
    },
};

function About() {
    const { ref: heroRef, inView: heroInView } = useInView({ triggerOnce: true, threshold: 0.1 });
    const { ref: storyRef, inView: storyInView } = useInView({ triggerOnce: true, threshold: 0.1 });

    return (
        <div>
            <div ref={heroRef}
                 className={`home-hero ak-primary-bg fade-in-section ${heroInView ? 'animate-fade-up' : ''}`}>
                <div className="highlight-wrapper">
                    <img
                        src={highlightExpert}
                        alt=""
                        className="highlight-honest-image"
                    />
                    <h1 className="semi-bold f-55 ak-white hero-title-h1 highlight-honest-text">
                        Wesley Wong
                    </h1>
                </div>
            </div>

            <div ref={storyRef} className={`home-about fade-in-section ${storyInView ? 'animate-fade-up' : ''}`}>
                <img alt="" src={logoSvg} className={"about-svg"}/>
                <div className="about-container" style={styles.container}>
                    <div style={styles.imageContainer}>
                        <img src="/wes.jpg" alt="Wesley Wong" width="780" height="975" style={styles.image}/>

                        <div style={styles.profileCard}>
                            <h2 style={styles.profileName}>Wesley Wong</h2>
                            <p style={styles.profileTitle}>Lawyer</p>
                        </div>

                        <div style={styles.profileDetails}>
                            <p><strong>Languages:</strong> English, Cantonese</p>
                            <p><strong>Email:</strong> <a className="contact-detail-link" href="mailto:wes@arkhamlaw.com">wes@arkhamlaw.com</a></p>
                        </div>
                    </div>

                    <div style={styles.textContainer}>
                        <p>
                            <strong>Wesley Wong</strong> was called to the bar in 2020 and maintains a broad legal
                            practice with a primary focus on immigration, residential and commercial real estate law.
                        </p>
                        <p>
                            In the area of immigration, Wesley is experienced in handling a wide range of matters,
                            including economic class applications, family sponsorships, temporary resident visas,
                            Humanitarian & Compassionate applications, and Temporary Resident Permits. His comprehensive
                            understanding of the complex and evolving landscape of immigration law allows him to guide
                            clients through each stage of the process with confidence, diligence, and clarity.
                        </p>
                        <p>
                            Wesley is also well-versed in judicial review proceedings. When immigration applications are
                            refused, he is equipped to file Applications for Leave and Judicial Review and advocate
                            effectively for his clients before the Federal Court of Canada. His ability to assess the
                            legal merits of a case and present strong, well-reasoned arguments has helped clients
                            overcome significant challenges in their immigration journeys.
                        </p>
                        <p>
                            In addition to his immigration work, Wesley assists clients with both residential and
                            commercial real estate matters. He regularly advises on contract review and guides clients
                            through purchase, sale, and refinancing transactions. His approach is practical,
                            client-focused, and detail-oriented—ensuring that clients are well-informed throughout the
                            process.
                        </p>
                        <p>
                            Wesley and his team work closely with clients, realtors, mortgage brokers, and other
                            professionals to ensure every aspect of the transaction proceeds smoothly and efficiently.
                            His goal is to make each real estate experience as seamless and positive as possible.
                            Whether navigating immigration pathways or closing real estate deals, Wesley is committed to
                            providing sound legal advice and delivering personalized, results-driven service to every
                            client.
                        </p>
                        <p>
                            In his spare time, Wesley is an avid cyclist who regularly participates in annual Gran Fondo
                            events across Alberta and British Columbia. His passion for the sport has also taken him
                            abroad, including cycling adventures in France and Croatia. Wesley is equally committed to
                            giving back to the community and has actively participated in the Enbridge Tour Alberta for
                            Cancer. Over the years, he has proudly ridden with Team RBC and Team Mizuho Bank, raising
                            funds in support of the Alberta Cancer Foundation. His dedication to both athletic pursuits
                            and charitable causes reflects his drive, discipline, and desire to make a meaningful impact
                            beyond the legal profession.
                        </p>
                    </div>
                </div>
            </div>

            <Footer/>
        </div>
    );
}

export default About;
